/**
 * Fix for Terms & Conditions checkbox in mobile Safari
 * This script ensures the checkbox works correctly in all browsers
 */
(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Get the terms condition link element
    const termsLink = document.querySelector('a[data-term-condition]');
    
    // Get the checkout button
    const checkoutButton = document.getElementById('cart-checkout');
    
    // Get the hidden checkbox input
    const checkboxInput = document.getElementById('cart_conditions');
    
    // Exit if any of these elements don't exist
    if (!termsLink || !checkoutButton || !checkboxInput) return;
    
    // Function to manually trigger a change event
    function triggerChangeEvent(element) {
      const event = new Event('change', { bubbles: true });
      element.dispatchEvent(event);
    }
    
    // Add touchstart and click event listeners to the terms link
    ['touchstart', 'click'].forEach(function(eventType) {
      termsLink.addEventListener(eventType, function(e) {
        // Prevent default link behavior
        e.preventDefault();
        
        // Toggle checkbox state
        checkboxInput.checked = !checkboxInput.checked;
        
        // Trigger change event so existing listeners can pick it up
        triggerChangeEvent(checkboxInput);
        
        // Directly update checkout button state
        checkoutButton.disabled = !checkboxInput.checked;
        
        // Add visual indicator that link was clicked
        if (checkboxInput.checked) {
          termsLink.classList.add('terms-agreed');
        } else {
          termsLink.classList.remove('terms-agreed');
        }
        
        // Return false to prevent bubbling
        return false;
      }, { passive: false });
    });
    
    // Handle the original checkbox change event as a backup
    checkboxInput.addEventListener('change', function() {
      checkoutButton.disabled = !this.checked;
      
      if (this.checked) {
        termsLink.classList.add('terms-agreed');
      } else {
        termsLink.classList.remove('terms-agreed');
      }
    });
    
    // Add style to show visual indicator
    const style = document.createElement('style');
    style.textContent = `
      a[data-term-condition].terms-agreed {
        font-weight: bold;
        text-decoration: underline;
      }
    `;
    document.head.appendChild(style);
  });
})();